import { supabase } from "@/integrations/supabase/client";
import { generateEventId } from "./eventId";

/**
 * Track WhatsApp click server-side via Meta Conversions API
 * This captures conversions from users who block browser pixels
 */
/**
 * Get Facebook click ID from URL or cookie
 */
const getFbc = (): string | undefined => {
  // Check URL for fbclid
  const urlParams = new URLSearchParams(window.location.search);
  const fbclid = urlParams.get('fbclid');
  if (fbclid) {
    // Format: fb.1.timestamp.fbclid
    return `fb.1.${Date.now()}.${fbclid}`;
  }
  return undefined;
};

/**
 * Get Facebook browser ID from cookie
 */
const getFbp = (): string | undefined => {
  const match = document.cookie.match(/_fbp=([^;]+)/);
  return match ? match[1] : undefined;
};

/**
 * Track WhatsApp click server-side via Meta Conversions API
 * This captures conversions from users who block browser pixels
 */
export const trackWhatsAppServerSide = async (params: {
  source: string;
  language: string;
  eventSourceUrl?: string;
  trafficSource?: string;
  trafficMedium?: string;
  trafficCampaign?: string;
}): Promise<string | null> => {
  try {
    const eventId = generateEventId();
    
    const { error } = await supabase.functions.invoke("track-whatsapp", {
      body: {
        event_id: eventId,
        event_source_url: params.eventSourceUrl || window.location.href,
        language: params.language,
        source: params.source,
        client_user_agent: navigator.userAgent,
        fbc: getFbc(),
        fbp: getFbp(),
        traffic_source: params.trafficSource,
        traffic_medium: params.trafficMedium,
        traffic_campaign: params.trafficCampaign,
      },
    });

    if (error) {
      console.error("Server-side WhatsApp tracking error:", error);
      return null;
    }

    return eventId;
  } catch (err) {
    // Silently fail - don't disrupt user experience
    console.error("Failed to track WhatsApp server-side:", err);
    return null;
  }
};
